import React from "react";
import moment from "moment";
import { MdArrowForwardIos } from "react-icons/md";

const SoldSlot = ({ data, setBookingDetails }) => {
  return (
    <div className="mx-auto mt-5">
      {/* Bookings Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 cursor-pointer">
        {data?.map((booking) => (
          <div
            onClick={() => setBookingDetails(booking)}
            key={booking.id}
            className="bg-white p-4 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 group border border-gray-200"
          >
            {/* Card Header with Gradient */}
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                {booking?.buyerPtofileImageUrl ? (
                  <img
                    src={booking?.buyerPtofileImageUrl}
                    alt={booking?.buyerPtofileImageUrl}
                    className="w-12 h-12 rounded-full border-2 border-white shadow-md object-cover"
                  />
                ) : (
                  <div className="flex items-center justify-center text-md text-white font-bold w-12 h-12 rounded-full bg-highlight border-2 border-white shadow-md">
                    {booking?.buyerName && booking?.buyerName[0]}
                  </div>
                )}
                <h3 className="text-black font-medium text-lg truncate">
                  {booking?.buyerName}
                </h3>{" "}
              </div>
              <MdArrowForwardIos />
            </div>

            {/* Card Body */}
            <div className="pt-3 space-y-1">
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-500 font-medium">
                  Booked On
                </span>
                <span className="font-medium text-sm text-highlight">
                  {moment(booking?.createdDateTime).format("DD/MM/YYYY")}
                </span>
              </div>

              {/*  Booking Date */}
              {booking?.venueCardData?.length > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500 font-medium">
                    Booked For
                  </span>
                  <span className="font-medium text-sm text-highlight">
                    {moment(booking?.venueCardData[0]?.bookingDate).format(
                      "DD/MM/YYYY"
                    )}
                  </span>
                </div>
              )}

              {/* Amount */}

              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-500 font-medium">
                  Amount Paid
                </span>
                <span className="font-medium text-sm text-green-600">
                  ₹{booking.totalAmount}
                </span>
              </div>

              {/* {refundedAmount} */}
              {booking?.refundedAmount && booking?.refundedAmount != 0 ? (
                <div className="pt-1">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500 font-medium">
                      Refunded Amount
                    </span>
                    <span className="font-semibold text-sm text-green-600">
                      ₹{booking.refundedAmount}
                    </span>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SoldSlot;
